<template>
  <v-layout fluid fill-height class="trans-background idcs-pane-back">
    <v-data-table
      :headers="headers"
      :items="trans"
      :loading="loading"
      :options.sync="pagination"
      :page.sync="currentPage"
      :server-items-length="totalItems"
      :items-per-page="10"
      :footer-props="{
        itemsPerPageOptions: [10, 50, 100], // -> Add this example
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-less-than',
        nextIcon: 'mdi-greater-than',
        itemsPerPageText: $t('label.rowPerPage')
      }"
      show-expand
      item-key="pos"
      class="elevation-1 table-fluid transparent px-4"
      :sort-desc="false"
      :sort-by="'created'"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:progress>
        <div class="progress-container">
          <v-progress-circular :size="100" :width="7" color="green" indeterminate></v-progress-circular>
        </div>
      </template>
      <template v-slot:top>
        <v-layout fluid class="align-center" wrap>
          <v-flex>
            <v-btn :disabled="trans.length==0" icon @click="d_print=true">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
            <date-picker
              v-model="sd"
              range
              confirm
              clearable
              @confirm="newRange"
              :shortcuts="shortcuts"
              :lang="$i18n.locale"
              :disabled="!dataOn"
              :input-class="dataOn?'idcs-data-pick':'idcs-data-pick-off'"
              class="idcs-picker-wrap"
            ></date-picker>
            <v-btn
              icon
              @click="dataOn=!dataOn"
              :color="dataOn?'green':'red'"
              class="hidden-xs-only"
            >
              <v-icon>mdi-calendar-check-outline</v-icon>
            </v-btn>
          </v-flex>
          <v-flex>
            <div style="margin-top: 25px;">
              <v-checkbox v-model="all_data" :label="$t('trans.all_data')"></v-checkbox>
            </div>
          </v-flex>
          <v-flex>
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('search.pattern')"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              v-model="search"
              clearable
              :disabled="filterPane"
              v-model.trim="search"
              @click:prepend-inner="applySearch"
              @keyup.enter="applySearch"
              @keyup.escape="resetSearch"
              @click:clear="resetSearch"
              class="search-str"
            ></v-text-field>
          </v-flex>
          <v-flex class="text-right">
            <v-btn
              v-show="filterActive && !filterPane"
              icon
              @click="resetFilter"
              color="error"
              class="f-btn-1"
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="filterPane=!filterPane"
              :class="'f-btn-2-'+(filterActive && !filterPane)"
            >
              <v-icon
                v-text="(!filterPane?'mdi-filter-menu':'mdi-filter')+(!filterActive?'-outline':'')"
              ></v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-scroll-y-transition :appear="true">
          <v-layout
            v-show="filterPane"
            wrap
            class="mb-4 idcs-dialog-back filter-pane"
            justify-space-around
          >
            <v-flex xs11 md4 lg3 class="mt-4">
              <v-text-field
                prepend-inner-icon="fa-cash-register"
                v-model="filters.terminal"
                outlined
                shaped
                clearable
                dense
                @keypress.enter="applyFilter"
                :background-color="filters.terminal?'yellow lighten-5':''"
                :placeholder="$t('search.terminal')"
                :label="$t('field.terminal')"
                color="black"
              ></v-text-field>
            </v-flex>
            <v-flex xs11 md4 lg3 class="mt-md-4">
              <v-autocomplete
                prepend-inner-icon="fa-store"
                v-model="filters.subcompany"
                outlined
                shaped
                clearable
                dense
                :background-color="filters.subcompany?'yellow lighten-5':''"
                :label="$t('field.subcompany')"
                :placeholder="$t('search.subcompanies')"
                :items="$store.getters['struct/subcompanies']"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs11 md3 lg3 class="mt-md-4">
              <v-autocomplete
                prepend-inner-icon="fa-cog"
                v-model="filters.operation"
                outlined
                shaped
                dense
                clearable
                :background-color="filters.operation?'yellow lighten-5':''"
                :label="$t('field.operation')"
                :placeholder="$t('search.operation')"
                :items="$store.getters['struct/operations']"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs11 md4 lg2 class="mt-md-4">
              <v-text-field
                v-model.trim="filters.card"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :placeholder="$t('search.card')"
                :background-color="filters.card?'yellow lighten-5':''"
                :label="$t('field.card')"
              ></v-text-field>
            </v-flex>
            <v-flex xs11 md4 lg2 class="mt-md-4">
              <v-text-field
                v-model.trim="filters.first_name"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :background-color="filters.first_name?'yellow lighten-5':''"
                :label="$t('card.prof.first_name')"
              ></v-text-field>
            </v-flex>
            <v-flex xs11 md3 lg2 class="mt-md-4">
              <v-text-field
                v-model.trim="filters.second_name"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :background-color="filters.second_name?'yellow lighten-5':''"
                :label="$t('card.prof.second_name')"
              ></v-text-field>
            </v-flex>
            <v-flex xs5 md3 lg2 class="mt-md-4">
              <v-text-field
                prefix="€"
                v-model="filters.amount1"
                :items="trans_status"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                placeholder=" "
                :background-color="filters.amount1?'yellow lighten-5':''"
                :label="$t('field.amount1.'+$store.getters.iface)"
              ></v-text-field>
              <!--<v-text-field v-model.trim="filters.status" label="Status"></v-text-field>!-->
            </v-flex>
            <v-flex xs5 md3 lg2 class="mt-md-4">
              <v-text-field
                prefix="€"
                v-model="filters.amount2"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                placeholder=" "
                :background-color="filters.amount2?'yellow lighten-5':''"
                :label="$t('field.amount2.'+$store.getters.iface)"
              ></v-text-field>
              <!--<v-text-field v-model.trim="filters.status" label="Status"></v-text-field>!-->
            </v-flex>
            <v-flex xs11 md5 lg3 align-center justify-end d-flex class="pb-4">
              <v-btn rounded @click="applyFilter" small color="accent" class="white--text mr-2">
                <v-icon>mdi-check</v-icon>
                {{$t("button.apply")}}
              </v-btn>
              <v-btn small :disabled="!filterActive" rounded @click="resetFilter" color="error">
                <v-icon>mdi-close</v-icon>
                {{$t("button.reset")}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-scroll-y-transition>
        <v-divider></v-divider>
      </template>
      <template v-slot:item="{headers, item, isExpanded, expand}">
        <tr :class="(item.pos%2==0?'idcs-data-back':'idcs-data-back2')">
          <template v-for="h in headers">
            <td v-if="h.value=='card'" :key="h.value">
              <TableFieldCard :card="item.card"></TableFieldCard>
            </td>
            <td v-else-if="h.value=='amount1'" :key="h.value" :align="h.align">
              <span v-if="item.status==200">{{item.amount1 | currency}}</span>
              <span
                v-else-if="item.status==201"
                class="amount-201 warning--text"
              >{{item.amount1|currency}}</span>
              <span
                v-else-if="item.status==202"
                class="amount-202 error--text"
              >{{item.amount1|currency}}</span>
              <span v-else>{{item.amount1}}</span>
            </td>
            <td v-else-if="h.value=='amount2'" :key="h.value" :align="h.align">
              <span v-if="item.status==200">{{item.amount2 | currency}}</span>
              <span v-else-if="item.status==201" class="warning--text">
                <v-chip color="warning" text-color="white">
                  <v-icon class="icon-amount2-201">fa-receipt</v-icon>
                  {{item.amount2}}
                </v-chip>
              </span>
              <span
                v-else-if="item.status==202"
                class="amount-202 error--text"
              >{{item.amount2|currency}}</span>
              <span v-else>{{item.amount2}}</span>
            </td>
            <td v-else-if="h.value=='created'" :key="h.value">{{item.created | dt-sec}}</td>
            <td v-else-if="h.value=='status'" :key="h.value">{{$t('status.'+item.status)}}</td>
            <td v-else-if="h.value=='data-table-expand'" :key="h.value">
              <v-btn
                x-small
                icon
                @click="expand(!isExpanded)"
                :color="!isExpanded?'blue lighten-2':'blue lighten-4'"
              >
                <v-icon>{{isExpanded?'fa-angle-double-up':'fa-angle-double-down'}}</v-icon>
              </v-btn>
            </td>
            <td v-else :key="h.value" :align="h.align">{{item[h.value]}}</td>
          </template>
        </tr>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <v-scroll-y-transition :appear="true">
          <tr>
            <td
              :colspan="headers.length"
              :class="'expand-td '+ (item.pos%2==0?'idcs-data-back':'idcs-data-back2')"
            >
              <v-layout row wrap class="py-2">
                <div v-for="i in details" :key="i.text">
                  <v-flex v-if="testIface(i) && item[i.value]" class="ma-2 pa-2 detail-main">
                    <div class="detail-header">{{i.text}}</div>
                    <div v-if="i.value=='rec_nr'">
                      <span class="accent--text">
                        <v-chip color="accent" text-color="white">
                          <v-icon class="icon-amount2-201">fa-receipt</v-icon>
                          {{item[i.value]}}
                        </v-chip>
                      </span>
                    </div>
                    <div
                      v-else
                      class="detail-value"
                    >{{i.filter ? $options.filters[i.filter](item[i.value]) : item[i.value]}}</div>
                  </v-flex>
                </div>
              </v-layout>
            </td>
          </tr>
        </v-scroll-y-transition>
      </template>
      <template v-slot:body.append="{headers}">
        <td colspan="4" class="detail-row">
          <v-subheader>{{$t('label.modified')+': '+ lastUpdate.format("H:mm:ss")}}</v-subheader>
        </td>
        <td :colspan="headers.length-8" align="right" class="detail-row">
          <v-icon v-if="totalItems>0 && !all_data">mdi-sigma</v-icon>
        </td>
        <td align="right" class="detail-row">
          <span v-show="!all_data">{{sum1|currency}}</span>
        </td>
        <td align="right" class="detail-row">
          <span v-show="!all_data">{{sum2|currency}}</span>
        </td>
        <td colspan="2" align="right" class="detail-row">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-icon class="value-count">fa-shopping-cart</v-icon>
                <span>{{totalItems}}</span>
              </div>
            </template>
            <span>{{$t("trans.tooltip.count")}}</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <PrintDialog v-model="d_print" :items="details" @click:ok="printPage" />
  </v-layout>
</template>

<script>
//import axios from "axios";
import app from "@/app.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import TableFieldCard from "@/components/Table-Field-Card";
//import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
//import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import PrintDialog from "@/components/PrintDialog";

export default {
  components: { DatePicker, TableFieldCard, PrintDialog },
  data() {
    return {
      d_print: false,
      snackbar: false,
      snackMsg: "",
      dataOn: 1,
      sum1: 0,
      sum2: 0,
      all_data: false,
      // dateRange: {
      //   startDate: new Date(),
      //   endDate: new Date()
      // },
      sd: [new Date(), new Date()],
      filters: {
        card: "",
        terminal: "",
        company: "",
        subcompany: "",
        operation: "",
        first_name: "",
        second_name: ""
      },
      trans_status: [
        { text: this.$t("status.200"), value: 200 },
        { text: this.$t("status.201"), value: 201 },
        { text: this.$t("status.202"), value: 202 }
      ],
      lastUpdate: this.$moment(),
      filterPane: false,
      filterActive: false,
      search: "",
      searchActive: false,
      currentPage: 1,
      loading: false,
      totalItems: 0,
      pagination: {},
      trans: [],
      shortcuts: [
        {
          text: this.$t("picker.today"),
          onClick() {
            return [new Date(), new Date()];
          }
        },
        {
          text: this.$t("picker.yesterday"),
          onClick() {
            const f = moment()
              .subtract(1, "day")
              .startOf("day")
              .toDate();
            const e = moment()
              .subtract(1, "day")
              .endOf("day")
              .toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.currentWeek"),
          onClick() {
            const f = moment()
              .startOf("week").isoWeekday(1)
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.previousWeek"),
          onClick() {
            const f = moment()
              .subtract(1, "week")
              .startOf("week").isoWeekday(1)
              .toDate();
            const e = moment()
              .subtract(1, "week")
              .endOf("week")
              .toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.currentMonth"),
          onClick() {
            const f = moment()
              .startOf("month")
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.previousMonth"),
          onClick() {
            const f = moment()
              .subtract(1, "months")
              .startOf("month")
              .toDate();
            const e = moment()
              .subtract(1, "months")
              .endOf("month")
              .toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.fromPreviousMonth"),
          onClick() {
            const f = moment()
              .subtract(1, "months")
              .startOf("month")
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.fromStartYear"),
          onClick() {
            const f = moment()
              .startOf("year")
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        }
      ],
      details: [
        { text: this.$t("card.prof.first_name"), value: "first_name" },
        { text: this.$t("card.prof.second_name"), value: "second_name" },
        { text: this.$t("field.receipt"), value: "rec_nr" },
        {
          text: this.$t("field.debit_0"),
          value: "debit_0",
          align: "right",
          filter: "currency"
        },
        {
          text: this.$t("field.debit_n"),
          value: "debit_n",
          filter: "currency",
          minusface: [1]
        },
        {
          text: this.$t("field.amount_discount_n"),
          value: "amount_discount_n",
          filter: "currency",
          minusface: [1]
        },
        {
          text: this.$t("field.amount_discount_0"),
          value: "amount_discount_0",
          filter: "currency",
          minusface: [1]
        },
        {
          text: this.$t("field.current_discount_0"),
          value: "current_discount_0",
          filter: "percent",
          minusface: [1]
        },
        { text: this.$t("field.points_0"), value: "points_0", minusface: [1] },
        { text: this.$t("field.bonus_0"), value: "bonus_0" },
        { text: this.$t("field.counter_n"), value: "counter_n" },
        {
          text: this.$t("field.discount_n"),
          value: "discount_n",
          filter: "percent",
          minusface: [1]
        },
        {
          text: this.$t("field.discount_0"),
          value: "discount_0",
          filter: "percent",
          minusface: [1]
        },
        /*{
          text: this.$t("field.refCard"),
          filter: "refcard",
          value: "sys_data"
        },
        {
          text: this.$t("field.realDate"),
          filter: "realdate",
          value: "sys_data"
        },*/
        { text: this.$t("field.counter_n"), value: "counter_n", minusface: [1] }
      ],
      headers: [
        { text: "#", align: "center", value: "pos", sortable: false },
        {
          text: this.$t("field.created"),
          align: "left",
          value: "created",
          filter: "dt-time"
        },
        { text: this.$t("field.card"), align: "left", value: "card" },
        { text: this.$t("field.company"), align: "center", value: "company" },
        {
          text: this.$t("field.subcompany"),
          align: "center",
          value: "subcompany"
        },
        { text: this.$t("field.terminal"), align: "center", value: "terminal" },
        { text: this.$t("field.system"), align: "center", value: "system" },
        {
          text: this.$t("field.operation"),
          align: "center",
          value: "operation"
        },
        {
          text: this.$t("field.amount1." + this.$store.getters.iface),
          align: "right",
          value: "amount1",
          width: "130",
          sortable: true,
          filter: "currency"
        },
        {
          text: this.$t("field.amount2." + this.$store.getters.iface),
          align: "right",
          value: "amount2",
          width: "130",
          sortable: true,
          filter: "currency"
        },
        {
          text: this.$t("field.status"),
          align: "center",
          label: "status.",
          value: "status"
        },
        { text: "", value: "data-table-expand" }
      ]
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    sd: {
      handler() {
        if (this.filterPane) return;
        this.currentPage = 1;
        this.getDataFromApi();
      }
    },
    all_data: {
      handler() {
        this.getDataFromApi();
      }
    }
  },
  mounted() {
    if (!this.$store.getters["struct/isLoaded"]) {
      this.$store.dispatch("struct/LOAD_STRUCT");
    }
  },
  created() {
    if (this.$route.query.a2) {
      this.filterPane = true;
      this.filters.amount2 = this.$route.query.a2;
    }
    if (this.$route.query.dt) {
      this.sd[0] = new Date(this.$route.query.dt);
      this.sd[1] = new Date(this.$route.query.dt);
    }
    if (this.$route.query.sc) {
      this.filters.subcompany = this.$route.query.sc;
      this.filterPane = true;
    }
  },
  methods: {
    testIface(i) {
      if (!i.minusface) return true;
      return i.minusface.indexOf(this.$store.getters.iface) == -1;
    },
    newRange() {
      this.currentPage = 1;
      this.getDataFromApi();
    },
    printPage() {
      this.loadData(true).then(response => {
        this.loading = false;
        let headers = {
          title: this.$t("report.title.trans"),
          created: new Date().toString(),
          search: this.search,
          filter: this.filters,
          sd: this.$options.filters["dt-time"](this.sd[0]),
          ed: this.$options.filters["dt-time"](this.sd[1])
        };
        try {
          if (headers.filter.subcompany)
            headers.filter.subcompany = this.$store.getters[
              "struct/subCompanyById"
            ](headers.filter.subcompany).text;
          if (headers.filter.operation)
            headers.filter.operation = this.$store.getters[
              "struct/operationById"
            ](headers.filter.operation).text;
        } catch (error) {
          console.log(error);
        }
        let footers = { totals: {} };
        if (!this.all_data) {
          (footers.totals.amount1 = response.sum1),
            (footers.totals.amount2 = response.sum2);
        }
        let head = this.headers.slice();
        this.details.forEach(e => {
          if (e.prn) {
            head.push(e);
          }
        });
        app.generatePrintPage(response, head, headers, footers);
      });
    },
    applySearch() {
      for (let k in this.filters) {
        this.filters[k] = "";
      }
      this.searchActive = true;
      this.currentPage = 1;
      this.getDataFromApi();
    },
    applyFilter() {
      this.currentPage = 1;
      this.filterActive = true;
      this.getDataFromApi();
    },
    resetSearch() {
      for (let k in this.filters) {
        this.filters[k] = "";
      }
      this.search = "";
      this.currentPage = 1;
      this.filterPane = false;
      this.filterActive = false;
      this.searchActive = false;
      this.getDataFromApi();
    },
    resetFilter() {
      this.resetSearch();
    },
    getDataFromApi() {
      this.trans = [];
      this.loadData()
        .then(response => {
          this.trans = response.items;
          this.totalItems = response.count;
          this.loading = false;
          this.lastUpdate = this.$moment();
          this.sum1 = response.sum1;
          this.sum2 = response.sum2;
        })
        .catch(e => {
          this.loading = false;
          alert(e);
        });
    },
    buildParams(unlimit) {
      let sort = "";
      if (this.pagination.sortBy.length) {
        sort = this.pagination.sortBy[0];
      }
      if (this.pagination.sortDesc.length) {
        sort += this.pagination.sortDesc[0] ? " desc" : " asc";
      }
      let filt = {};
      for (var k in this.filters) {
        if (
          this.filters[k] == null ||
          typeof this.filters[k] == undefined ||
          this.filters[k] == ""
        )
          continue;
        filt[k] = this.filters[k];
      }
      if (!this.all_data) filt.status = 200;
      let params = {
        pattern: this.search,
        filter: filt,
        limit: unlimit ? -1 : this.pagination.itemsPerPage,
        offset: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        order: sort
      };
      if (this.dataOn) {
        if (this.sd[0] == null) this.sd[0] = new Date();
        if (this.sd[1] == null) this.sd[1] = new Date();
        params.sd = this.$moment(this.sd[0]).format("YYYYMMDD");
        params.ed = this.$moment(this.sd[1]).format("YYYYMMDD");
      }
      return params;
    },
    loadData(unlimit) {
      this.loading = true;
      return app.loadTransactions(this.buildParams(unlimit));
    }
  }
};
</script>
<style lang="scss" scoped>
.progress-container {
  width: 100%;
  text-align: center;
  padding: 20px;
}
/*.main-toolbar {
  padding-top: 8px;
}*/
.f-btn-2-false {
  /*  height: 40px !important;
  width: 40px !important;*/
  border-radius: 25px 25px 25px 25px;
  background-color: rgb(232, 245, 233);
  /*margin-right: -10px !important;*/
}
.f-btn-2-true {
  /*  height: 40px !important;
  width: 40px !important;*/
  border-radius: 0 25px 25px 0;
  background-color: rgb(232, 245, 233);
  /*margin-right: -10px !important;*/
}
.f-btn-1 {
  /*  height: 40px !important;
  width: 40px !important;*/
  border-radius: 25px 0 0 25px;
  background-color: antiquewhite;
  /*margin-right: -10px !important;*/
}
.table-fluid {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.detail-main {
  text-align: center;
}
.detail-row {
  background-color: ghostwhite;
}
.detail-header {
  text-align: center;
  font-size: x-small;
}
.detail-value {
  text-align: center;
  font-weight: bold;
}
.value-count {
  font-size: medium;
  margin-right: 10px;
}
.amount-201 {
  text-decoration: line-through;
}
.amount-202 {
  text-decoration: line-through;
}
.icon-amount2-201 {
  font-size: small;
  margin-right: 5px;
}
.filter-pane {
  border-radius: 25px;
}
/*.filter-btn-off {
  height: 40px !important;
  width: 40px !important;
  background-color: rgba(0, 0, 0, 0.06);
  margin-right: 4px;
  color: gray;
}
.filter-btn-on {
  height: 40px;
  width: 40px;
  color: green !important;
  background-color: #d0f5da;
  border-radius: 50px 50px 0px 0px;
  margin-right: 4px;
}*/
.search-str {
  margin-top: 20px;
}
.trans-background{
  background-image: url("../assets/transactions.svg");
  background-position: bottom;
}
</style>